import { render, staticRenderFns } from "./GraduationProjectScore.vue?vue&type=template&id=db784962&"
import script from "./GraduationProjectScore.vue?vue&type=script&lang=js&"
export * from "./GraduationProjectScore.vue?vue&type=script&lang=js&"
import style0 from "./GraduationProjectScore.vue?vue&type=style&index=0&id=db784962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports